import React, { Dispatch, FC, SetStateAction } from "react";
import styles from "./jump-menu.module.scss";
import { FaChevronRight } from "react-icons/fa";

interface Props {
  onClick: () => void;
  menuOpen: boolean;
}

const MenuTab: FC<Props> = ({ onClick, menuOpen }) => {
  const handleShowMenu = () => {
    onClick();
  };

  return (
    <div className={styles.menuTab} onClick={handleShowMenu}>
      <FaChevronRight style={{ transform: `rotate(${menuOpen ? 180 : 0}deg)` }} className={styles.arrow} />
    </div>
  );
};

export default MenuTab;
